import { gql } from 'graphql-request'

export const comunicadoFragment = gql`
  fragment ComunicadoFragment on Comunicado {
    id
    titulo
    mensagem
    createdDateTime
    envioDateTime
    motivoRejeicao
    dataHoraAgendamento
    status {
      id
      description
    }
    usuarioCriador {
      id
      nome
      email
    }
    usuarioAprovador {
      id
      nome
      email
    }
    grupos {
      id
      nome
    }
    usuariosRemovidos {
      id
      nome
    }
    etiquetas {
      id
      nome
    }
    arquivos {
      id
      nome
      tamanho
    }
    rascunho
    enviado
    emAprovacao
    rejeitado
    active
    emailsAvulsos {
      email
      status {
        name
        descricao
      }
    }
    departamento {
      id
      sigla
      nome
      assinatura
    }
    idParent
    templateName
  }
`
